import React from 'react';
import { Container } from 'react-bootstrap';
import './WelcomeSection.css';

const WelcomeSection = ({ section }) => {
  return (
    <section className="welcome-section homepage-section">
      <Container>
        <div 
          className="welcome-content" 
          dangerouslySetInnerHTML={{ __html: section.content }} 
        />
      </Container>
    </section>
  );
};

export default WelcomeSection;
